import { useTranslation } from 'react-i18next';
import { UserContext } from '../../contexts/UserContext';
import { useContext } from 'react';
import ComplainProgress from '../../components/Complains/ComplainProgress/ComplainProgress';
import Button from '../../components/Button/Button';
import Content from '../../components/Content/Content';
import Card from '../../components/Card/Card';
import { ReactComponent as OrderIcon } from '../../assets/icons/order.svg';
import OrderLine from '../../components/OrderLine/OrderLine';
import CardLine from '../../components/CardLine/CardLine';
import { getClaimFormUrl } from '../../utils/getClaimFormUrl';
import { isProduction } from '../../utils/isProduction';

export default function OrdersComplainPage() {
   const { t } = useTranslation('orders_complain');

   const { deals, loadingDeals, config } = useContext(UserContext);
   const orders = deals?.orderDeals.filter(
      (x) => x.canClaimBeCreatedForThisOrder
   );

   const getManualUrl = () => {
      if (!config || !isProduction()) return '';

      return getClaimFormUrl(config.name.toLowerCase(), config.language);
   };

   const handleClick = () => {
      if (!config || !isProduction()) {
         alert('Manual creation is disabled in test environments.');
      }
   };

   return (
      <Content>
         <h1>{t('title')}</h1>

         <ComplainProgress activeStep={0} />

         <Card title={t('orders')} loading={loadingDeals} icon={<OrderIcon />}>
            {orders &&
               orders.length > 0 &&
               orders.map((order) => (
                  <OrderLine
                     to={`/orders/${order.id}/complain`}
                     key={order.id}
                     order={order}
                  />
               ))}

            {(!orders || !orders.length) && !loadingDeals && (
               <CardLine>{t('no_orders')}</CardLine>
            )}
         </Card>

         <Button
            to={getManualUrl()}
            onClick={handleClick}
            target='_blank'
            small
         >
            {t('cant_see_your_order')}
         </Button>
      </Content>
   );
}
